import { render, staticRenderFns } from "./UIAutocomplete.vue?vue&type=template&id=618041c4&scoped=true"
import script from "./UIAutocomplete.vue?vue&type=script&lang=js"
export * from "./UIAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./UIAutocomplete.vue?vue&type=style&index=0&id=618041c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618041c4",
  null
  
)

export default component.exports